import eng from './eng'
import gb from './gb'
import big5 from './big5'

export default {
    big5,
    eng,
    gb
}